import { render } from "./ExamList.vue?vue&type=template&id=1bd532da&scoped=true"
import script from "./ExamList.vue?vue&type=script&lang=js"
export * from "./ExamList.vue?vue&type=script&lang=js"

import "./ExamList.vue?vue&type=style&index=0&id=1bd532da&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd532da"]])

export default __exports__